// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  configs: {
    myFatoorahApi: "https://apitest.myfatoorah.com/v2/",
    myFatoorahToken:
      "rLtt6JWvbUHDDhsZnfpAhpYk4dxYDQkbcPTyGaKp2TYqQgG7FGZ5Th_WD53Oq8Ebz6A53njUoo1w3pjU1D4vs_ZMqFiz_j0urb_BH9Oq9VZoKFoJEDAbRZepGcQanImyYrry7Kt6MnMdgfG5jn4HngWoRdKduNNyP4kzcp3mRv7x00ahkm9LAK7ZRieg7k1PDAnBIOG3EyVSJ5kK4WLMvYr7sCwHbHcu4A5WwelxYK0GMJy37bNAarSJDFQsJ2ZvJjvMDmfWwDVFEVe_5tOomfVNt6bOg9mexbGjMrnHBnKnZR1vQbBtQieDlQepzTZMuQrSuKn-t5XZM7V6fCW7oP-uXGX-sMOajeX65JOf6XVpk29DP6ro8WTAflCDANC193yof8-f5_EYY-3hXhJj7RBXmizDpneEQDSaSz5sFk0sV5qPcARJ9zGG73vuGFyenjPPmtDtXtpx35A-BVcOSBYVIWe9kndG3nclfefjKEuZ3m4jL9Gg1h2JBvmXSMYiZtp9MR5I6pvbvylU_PP5xJFSjVTIz7IQSjcVGO41npnwIxRXNRxFOdIUHn0tjQ-7LwvEcTXyPsHXcMD8WtgBh-wxR8aKX7WPSsT1O8d8reb2aR7K3rkV3K82K_0OgawImEpwSvp9MNKynEAJQS6ZHe_J_l77652xwPNxMRTMASk1ZsJL",
    /*myFatoorahApi : "https://api.myfatoorah.com/v2/",
    myFatoorahToken : "-3AeaFQo8OCGGHWmc_yCeu8dtbJl_-m9bbTJ6rS8cJFLQWXW01buu1StgIfB05QKUtn3VB66Jw92dhuPZLLrK9EG1lObUOvjvScApWhNCeupqBwx0nM8z0rldp2rCxySnz31CIF5hhNmbyUmXSvqHZuFppcw2om_7c0b9y7gwh_BJ79FsdvOU4DDp1UqM0yZFJfXx3s-qkcYlDJre3R5klngmoMKqOcv6ve5omOYHYnsi28Xo3Y8YnRGt44SJMQ1CASajVazCokyAW0HmwVNLhuch2SySCAHTUMwq7RvPJ5sNgYnJcUrWASb1RcurehtIHvuwWnLZ2t3qo9iuUnEAMJPZfM4gBcpiN95ehFjrHFBMn4SRSj21M8jTV8Up80gvwb5dxJ_H6I6a-i4pm42K6kjUBzEuEElRlIg0k912qHrofVNXjnYfLfmhctUGl6v_opFXl1Mqiba43pRVRZOc88AREsV0heZV6tLvGO3lv3cEQU4YuXbtVicK_DpxsuaD2Xzd4xarAi_xJFGOFAfJ6rIs5SY22M9MiOQ1RzdObclz454LlNbYERk6lMWINeg4LFMO0EvGmBAeiqZGIYa3UJG3sR22sr3WOU5cA0iZgHxSEZhs9aS8W-8wpYGP6RKxDV0A_tDkWFg-LBXcui4CcorkM_GIhzbd19N2ya9HvdLwMg-",
    */

    host:"dev.sadankwt.com",
    sadanApi : "http://157.245.85.48:3001/",
    crosApi:"https://proxy.sadankwt.com/",
    paymentCallBack:"https://dev.sadankwt.com/payment/",
    appHost:"https://app.sadankwt.com",
  
    // host: "localhost",
    // sadanApi: "http://localhost:3000/",
    // crosApi: "https://proxy.sadankwt.com/",
    // paymentCallBack: "https://6a19-197-40-246-134.eu.ngrok.io/payment/",
    // appHost: "https://app.sadankwt.com",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
